/**
 * @desc 后台确认价格
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ConfirmBidRecordParameter = {
  bidId?: string
}

const method = 'PUT'
const url = '/trade/operation/bidRecord/confirm'

export const confirmBidRecordApi = (
  params?: ConfirmBidRecordParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

confirmBidRecordApi.method = method
confirmBidRecordApi.url = url
